require('bootstrap-sass');
require('./dialog/dialog.scss');
var Radio = require('backbone.radio');
var Behavior = Marionette.Behavior.extend({
    initialize: function (options, view) {
        this.listenToOnce(view, 'modal:open', this.openModal);
    },
    openModal: function (callback) {
        this.view.dialog = this.view.channel.request('open', {
            view: this.view,
            callback: callback
        });
        this.listenToOnce(this.view, 'modal:close', this.closeModal);
    },
    closeModal: function (callback) {
        this.view.channel.request('close', {
            callback: callback
        });
    }
});

var Controller = Marionette.Controller.extend({
    channel: null,
    initialize: function (options) {
        var self = this;
        self.container = options.container;
        self.channel = options.channel || Radio.channel('dialog');
        self.view = new Dialog({
            channel: self.channel
        });
        self.container.show(self.view);

        _.bindAll(self, 'openModal', 'closeModal');

        self.channel.reply('open', function (options) {
            self.openModal(options);
            return self.view;
        });
        self.channel.reply('close', this.closeModal);
    },

    openModal: function (options) {
        this.view.openModal(options);
    },

    closeModal: function (options) {
        this.view.closeModal(options);
    }
});

/*
    Example usage

    Instantiation:
    var DialogController =
        require('treeline-shared-components/dialog').Controller;
    this.modalController = new DialogController({
        container: this.myDialogRegion
    });

    Show a view in the dialog:
    Radio.channel('dialog').request(
        'open',
        {
            view: new MyViewType(),
            callback: function myOnDialogShownCallback () {
                ...
            }
        }
    );

    Close the dialog:
    Radio.channel('dialog').request(
        'close',
        {
            callback: function myOnDialogClosedCallback () {
                ...
            }
        }
    );

*/

var Dialog = Marionette.LayoutView.extend({
    _currentViewCustomClassName: '',
    template: require('./dialog/dialog.tpl'),
    // TODO rtomaselli: temporarily removed the 'fade' class because
    // when showing consecutive dialogs due to the animation the
    // background was not getting removed properly. Add 'fade' back in
    // once we've figured out how to show consecutive dialogs properly.
    className: 'tl-dialog modal',
    attributes: {
        'tabindex': -1,
        'role': 'dialog'
    },
    regions: {
        content: '.modal-content'
    },
    events: {
        'click .close': 'closeModal'
    },
    triggers: {
        'show.bs.modal': { preventDefault: false, event: 'show:modal' },
        'shown.bs.modal': { preventDefault: false, event: 'after:show:modal' },
        'hide.bs.modal': { preventDefault: false, event: 'hide:modal' },
        'hidden.bs.modal': { preventDefault: false, event: 'after:hide:modal' }
    },
    openModal: function (options) {
        if (options && options.callback) {
            this.once('after:show:modal', options.callback);
        }
        this.setupModal(options);
        jQuery(this.$el).modal('show');
        if (options.fullScreen) {
            this.$el.addClass('tl-full-screen-dialog');
        } else {
            this.$el.removeClass('tl-full-screen-dialog');
        }
        this._currentViewCustomClassName = options.customClassName;
        this.$el.addClass(this._currentViewCustomClassName);
    },
    closeModal: function (options) {
        if (options && options.callback) {
            this.once('after:hide:modal', options.callback);
        }
        if (this.content.currentView) {
            this.content.currentView.trigger('close');
        }

        jQuery(this.$el).modal('hide');
        this.$el.removeClass('tl-full-screen-dialog');
        this.$el.removeClass(this._currentViewCustomClassName);
        this.teardownModal();
    },
    setView: function (view) {
        this.content.show(view);
    },
    setupModal: function (options) {
        if (this.isShown) {
            this.teardownModal();
        }
        this.content.show(options.view);
        this.isShown = true;
    },

    teardownModal: function () {
        if (!this.isShown) {
            return;
        }

        this.content.empty();
        this.isShown = false;
    },
    onShow: function () {
        jQuery(this.$el).modal({ show: false });
    }
});

module.exports = {
    Controller: Controller,
    Behavior: Behavior
};



/*****************
 ** WEBPACK FOOTER
 ** ./assets/vendor/treeline-shared-components/dialog.js
 ** module id = 458
 ** module chunks = 1 2 110
 **/